module.exports = __webpack_public_path__ + "img/25.ec1007f4.jpg";